import Vue from 'vue';
import iView from 'iview';
import Util from '../libs/util';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import {routers, otherRouter, appRouter,externalPart} from './router';
import store from '../store'
Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
};
const externalRouter = {
    // mode: 'history',
    routes: externalPart
};
// const externalRouter = {
//     // mode: 'history',
//     routes: externalPart
// };
export const router = new VueRouter(RouterConfig);
router.beforeEach((to, from, next) => {
    if(to.path==="/externalPart"||to.name==="external-part-login"){
        // 没有配置权限的路由, 直接通过
        Util.toDefaultPage([...routers], to.name, router, next);
    }else{
        //如果刷新页面后数据丢失
        // if(store.state.app.modelesArr.length == 0 && to.name!="login"){
        //     store.dispatch('getUserModules', {vm:router.app,callback:()=>{
        //         let accArr = store.state.app.modelesArr;
        //         accArr.forEach(item=>{
        //           if(typeof to.meta.accessName !="undefined"||to.meta.accessName=="" ){
        //             if(item.mNo == to.meta.accessName || to.meta.accessName.indexOf(item.mNo)>-1){
        //                 store.commit('setPermissions',item.permissions)
        //             }
        //           }
        //         })
        //     }});
        // }else if(localStorage.modelesArr){
        //     //跳转路由前循环权限数组并得到对应的路由权限
        //     let accArr = JSON.parse(localStorage.modelesArr);
        //     accArr.forEach(item=>{
        //       if(typeof to.meta.accessName !="undefined"||to.meta.accessName=="" ) {
        //         if (item.mNo == to.meta.accessName || to.meta.accessName.indexOf(item.mNo) > -1) {
        //           store.commit('setPermissions', item.permissions)
        //         }
        //       }
        //     })
        // }

        iView.LoadingBar.start();
        Util.title(to.meta.title);
        if (Cookies.get('locking') === '1' && to.name !== 'locking') { // 判断当前是否是锁定状态
            next({
                replace: true,
                name: 'locking'
            });
        } else if (Cookies.get('locking') === '0' && to.name === 'locking') {
            next(false);
        } else {
            if (((!Cookies.get('user')) || Cookies.get('user') == null) && to.name !== 'login') { // 判断是否已经登录且前往的页面不是登录页
                next({
                    name: 'login'
                });
            } else if (Cookies.get('user') && to.name === 'login') { // 判断是否已经登录且前往的是登录页
                Util.title();
                next({
                    name: 'home_index'
                });
            } else {
                const curRouterObj = Util.getRouterObjByName([otherRouter, ...appRouter], to.name);
                if (curRouterObj && curRouterObj.access !== undefined) { // 需要判断权限的路由
                    if (curRouterObj.access === parseInt(Cookies.get('access'))) {
                        Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
                    } else {
                        next({
                            replace: true,
                            name: 'error-403'
                        });
                    }
                } else { // 没有配置权限的路由, 直接通过
                    Util.toDefaultPage([...routers], to.name, router, next);
                }
            }
        }
    }
});

router.afterEach((to) => {
    // if(to.path==="/externalPart"||to.name==="external-part-login"){
    //     Util.openNewPage(router.app, "external-part-login", to.params, to.query);
    // }else{
        Util.openNewPage(router.app, to.name, to.params, to.query);
    // }
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

// 路由重复跳转报错问题
const VueRouterPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
      return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
  };


// WEBPACK FOOTER //
// ./src/router/index.js